import React from 'react';
import { Grid, Card, CardActionArea, Typography } from '@mui/material';

interface QuestionCount {
  id: string;
  label?: string;
  value: number;
}

interface QuestionCountSelectorProps {
  counts: QuestionCount[];
  selectedValue: string;
  onChange: (id: string) => void;
   unitLabel?: string;
}

const CARD_COLORS = [
  { bg: '#2196F3', border: '#2196F3' },
  { bg: '#9C27B0', border: '#9C27B0' },
  { bg: '#4CAF50', border: '#4CAF50' },
  { bg: '#FF9800', border: '#FF9800' },
  { bg: '#E91E63', border: '#E91E63' },
  { bg: '#009688', border: '#009688' },
];

const QuestionCountSelector: React.FC<QuestionCountSelectorProps> = ({
  counts,
  selectedValue,
  onChange,
  unitLabel,
}) => {
  return (
    <Grid container spacing={1}>
      {counts.map((count, index) => {
        const color = CARD_COLORS[index % CARD_COLORS.length];
        const isSelected = selectedValue === count.id;

        return (
          <Grid item xs={6} sm={3} key={count.id}>
            <Card
              elevation={isSelected ? 2 : 1}
              sx={{
                borderRadius: 1.5,
                border: isSelected ? '2px solid' : '1px solid',
                borderColor: isSelected ? color.border : '#e0e0e0',
                bgcolor: isSelected ? `${color.bg}20` : 'transparent',
                transition: 'all 0.2s ease',
                '&:hover': {
                  borderColor: color.border,
                  transform: 'translateY(-1px)',
                  boxShadow: 2,
                },
              }}
            >
              <CardActionArea onClick={() => onChange(count.id)} sx={{ p: 0.8 }}>
                <Typography
                  variant="h4"
                  align="center"
                  sx={{
                    fontSize: 12,
                    // fontWeight: 700,
                    color: isSelected ? color.border : '#000',
                  }}
                >
                  {count.value} {unitLabel}
                </Typography>

                {/* <Typography
                  variant="caption"
                  align="center"
                  display="block"
                  sx={{
                    fontSize: 9,
                    color: isSelected ? color.border : '#999',
                  }}
                >
                  {unitLabel}
                </Typography> */}
              </CardActionArea>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default QuestionCountSelector;